import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-20">
      <div className="text-xs font-mono uppercase tracking-[0.3em] text-slate-500">{t("auth.welcome")}</div>
      <h1 className="mt-2 font-display font-extrabold text-4xl tracking-tight">{t("auth.signIn")}</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-4">
        <div>
          <label className="text-xs font-mono uppercase tracking-widest">{t("auth.email")}</label>
          <input
            data-testid="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full h-11 px-3 border border-black/15 focus:border-electric focus:outline-none"
          />
        </div>
        <div>
          <label className="text-xs font-mono uppercase tracking-widest">{t("auth.password")}</label>
          <input
            data-testid="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full h-11 px-3 border border-black/15 focus:border-electric focus:outline-none"
          />
        </div>
        {error && <div data-testid="login-error" className="text-sm font-mono text-destructive">{error}</div>}
        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="w-full h-12 bg-ink text-white hover:bg-electric disabled:opacity-50 transition-colors text-xs font-mono uppercase tracking-[0.2em]"
        >
          {loading ? t("auth.signingIn") : t("auth.signInBtn")}
        </button>
        <div className="text-right">
          <Link
            to="/forgot-password"
            data-testid="login-forgot-link"
            className="text-xs font-mono uppercase tracking-widest text-slate-500 hover:text-electric"
          >
            {t("auth.forgotLink")}
          </Link>
        </div>
      </form>
      <div className="mt-6 text-sm">
        {t("auth.newHere")}{" "}
        <Link to="/register" data-testid="login-register-link" className="text-electric underline">
          {t("auth.createAccount")}
        </Link>
      </div>
    </div>
  );
}
